import { Select } from '@applyboard/crystal-ui';
import { assert } from "../../../../utils/assert";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export function NewViewAdminToggle(_ref) {
  var onChangeView = _ref.onChangeView,
    viewType = _ref.viewType;
  function onChange(view) {
    assert(view === 'admin' || view === 'rp');
    onChangeView(view);
  }
  return _jsxs(Select, {
    appearance: "styled",
    value: viewType,
    onChange: onChange,
    emphasis: "highlighted",
    intent: "primary",
    "aria-label": "Select a view",
    placeholder: "",
    children: [_jsx(Select.Option, {
      value: "admin",
      label: "Admin view"
    }), _jsx(Select.Option, {
      value: "rp",
      label: "RP/Student view"
    })]
  });
}